import { render, staticRenderFns } from "./BlockDesigner.vue?vue&type=template&id=3c5a05b8&scoped=true&"
import script from "./BlockDesigner.vue?vue&type=script&lang=js&"
export * from "./BlockDesigner.vue?vue&type=script&lang=js&"
import style0 from "./BlockDesigner.vue?vue&type=style&index=0&id=3c5a05b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5a05b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c5a05b8')) {
      api.createRecord('3c5a05b8', component.options)
    } else {
      api.reload('3c5a05b8', component.options)
    }
    module.hot.accept("./BlockDesigner.vue?vue&type=template&id=3c5a05b8&scoped=true&", function () {
      api.rerender('3c5a05b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/ubossOnePage/BlockDesigner.vue"
export default component.exports